// 3rd party
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpModule, Http, XHRBackend, RequestOptions } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DateAdapter } from '@angular/material';
import { HttpClientModule, HttpClient } from '@angular/common/http';

// adapters
import { CustomDateAdapter } from 'app/shared/adapters/custom-date-adapter';

// components
import { AppComponent } from 'app/app.component';

// modules
import { ReportsModule } from 'app/reports/reports.module';
import { AssaysModule } from 'app/assays/assays.module';
import { SharedModule } from 'app/shared/shared.module';
import { InstrumentsModule } from 'app/instruments/instruments.module';
import { CalibrationsModule } from 'app/calibrations/calibrations.module';
import { BudgetsModule } from 'app/budgets/budgets.module';
import { StandardsModule } from 'app/standards/standards.module';
import { LayoutModule } from 'app/shared/layout/layout.module';
import { ComponentsModule } from 'app/shared/components/components.module';
import { LoginModule } from 'app/login/login.module';
import { VerifyModule } from './verify/verify.module';

// routing
import { AppRouting } from 'app/app.routing';

// services
import { HttpInterceptor } from 'app/shared/services/http/http-interceptor.service';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { AuthGuard, AuthGuardLogin, AuthGuardLogout, AuthGuardInstruments, AuthGuardCalibrations, AuthGuardBudgets, AuthGuardStandards, AuthGuardReports, AuthGuardAssays } from 'app/shared/services/auth/auth.guard';

// functions
export function HttpInterceptorFactory(backend: XHRBackend, options: RequestOptions, router: Router, injector: Injector) {
  return new HttpInterceptor(injector, router, backend, options);
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    SharedModule,
    AppRouting,
    InstrumentsModule,
    CalibrationsModule,
    BudgetsModule,
    StandardsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    LayoutModule,
    ComponentsModule,
    LoginModule,
    ReportsModule,
    AssaysModule,
    HttpClientModule,
    VerifyModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    AuthService,
    {
      provide: Http,
      useFactory: HttpInterceptorFactory,
      deps: [XHRBackend, RequestOptions, Router, Injector],
    },
    AuthGuard,
    AuthGuardLogin,
    AuthGuardLogout,
    AuthGuardInstruments,
    AuthGuardCalibrations,
    AuthGuardBudgets,
    AuthGuardStandards,
    AuthGuardReports,
    AuthGuardAssays,
    { provide: DateAdapter, useClass: CustomDateAdapter }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts